function AntenatalCare() {
    return (
      <div className="container my-5">
        <h2 className="text-center mb-4">Antenatal Care Package</h2>
        
        <div className="row g-4">
          <div className="col-md-6">
            <div className="card h-100">
              <div className="card-header bg-primary text-white">
                <h4>Care Schedule</h4>
              </div>
              <div className="card-body">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">Every 4 weeks until 28 weeks</li>
                  <li className="list-group-item">Every 2 weeks until 36 weeks</li>
                  <li className="list-group-item">Weekly until delivery</li>
                </ul>
              </div>
            </div>
          </div>
  
          <div className="col-md-6">
            <div className="card h-100">
              <div className="card-header bg-primary text-white">
                <h4>Key Services</h4>
              </div>
              <div className="card-body">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">Ultrasound scans & fetal monitoring</li>
                  <li className="list-group-item">Gestational diabetes screening</li>
                  <li className="list-group-item">Nutritional counseling & Support</li>
                  <li className="list-group-item">Mental health support</li>
                  <li className="list-group-item">Birth planning sessions</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
  
        <div className="mt-4 alert alert-info">
          <h4>Expected Outcomes</h4>
          <p>Optimal maternal-fetal health through regular monitoring and early complication detection</p>
        </div>
      </div>
    );
  }


  export default AntenatalCare;